import { render, staticRenderFns } from "./DetalhesProjeto.vue?vue&type=template&id=6ffb1900&scoped=true"
import script from "./DetalhesProjeto.vue?vue&type=script&lang=js"
export * from "./DetalhesProjeto.vue?vue&type=script&lang=js"
import style0 from "./DetalhesProjeto.vue?vue&type=style&index=0&id=6ffb1900&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffb1900",
  null
  
)

export default component.exports